import React from 'react';
import Popover from './Popover.jsx';
import { GLOSSARY } from '../data.js';
import { useGuides } from './GuidesContext.jsx';

/* EduTip — a small (i) icon that reveals a glossary entry on hover.
   Props:
     term — key into GLOSSARY (required)
     label — optional override for the tooltip header

   Gated by Settings → Guide Controls → Educational popovers. When off,
   EduTip renders nothing so the surrounding layout tightens up. */
export default function EduTip({ term, label }) {
  const { eduTips } = useGuides();
  if (!eduTips) return null;
  const entry = GLOSSARY[term];
  const baseChip = "inline-flex items-center justify-center w-[14px] h-[14px] rounded-full text-[9px] font-bold not-italic font-['Georgia',serif] cursor-help ml-1 leading-none align-middle border";
  if (!entry) {
    return (
      <span
        className={`${baseChip} bg-[rgba(248,113,113,0.2)] text-accent-red border-[rgba(248,113,113,0.4)]`}
        title={`No glossary entry: ${term}`}
      >?</span>
    );
  }
  const content = (
    <div className="flex flex-col gap-[6px] min-w-[280px]">
      <div className="flex items-baseline gap-2 flex-wrap border-b border-[#334155] pb-1">
        <strong className="text-accent-gold text-[13px]">{label || entry.term}</strong>
        {entry.formula && (
          <code className="bg-[rgba(251,191,36,0.1)] text-accent-gold px-[6px] py-[2px] rounded-[4px] text-[10px]">{entry.formula}</code>
        )}
      </div>
      <p className="m-0 text-[#e2e8f0] text-[12px] font-medium">{entry.short}</p>
      {entry.long && entry.long !== entry.short && (
        <p className="m-0 text-[#cbd5e1] text-[11px] leading-[1.6]">{entry.long}</p>
      )}
    </div>
  );
  return (
    <Popover content={content} maxWidth={360}>
      <span
        className={`${baseChip} bg-[rgba(251,191,36,0.2)] text-accent-gold border-[rgba(251,191,36,0.4)] hover:bg-[rgba(251,191,36,0.4)]`}
        aria-label={`Definition: ${entry.term}`}
      >i</span>
    </Popover>
  );
}
